import {Component, Input} from '@angular/core';
import {LearningPackageStudyProgressResponseDto} from '../../../../../types/LearningPackageStudyProgressResponseDto';

@Component({
    selector: 'mm-learning-progress-insight-popup',
    templateUrl: './learning-progress-insight-popup.component.html',
    styleUrl: './learning-progress-insight-popup.component.scss',
    standalone: false
})
export class LearningProgressInsightPopupComponent {

    @Input({required: true})
    public studyProgress!: LearningPackageStudyProgressResponseDto;
}
